
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as indexVIwG6r374aioNOIHT2IFPE9_45TkLlxkrLIdzeRk6_45FDMMeta } from "/var/www/hotlot-staging/web/pages/index.vue?macro=true";
import { default as contactzs1zHnjp3smuS5jSh8U5wRgrQUdSKPZHRrWVI1nA728Meta } from "/var/www/hotlot-staging/web/pages/contact.vue?macro=true";
import { default as welcomeChlKx71VLwYXOlqE31EgvLDduecwCLvlaEU67dVaEXcMeta } from "/var/www/hotlot-staging/web/pages/welcome.vue?macro=true";
import { default as favoritesAUAtTqY_45gCGGRWxsVpy7iB29YbkA77OzBuyL4b_459fGcMeta } from "/var/www/hotlot-staging/web/pages/favorites.vue?macro=true";
import { default as faqTKI1RmKKaes_47K2roJm4D9GBdVBaJj2cM06Vg4oWsUMeta } from "/var/www/hotlot-staging/web/pages/legal/faq.vue?macro=true";
import { default as verifyP_OoqZ_Kz9s_ieVm5_45SCQuxbsY0ojyz8gaKZKD7gkXYMeta } from "/var/www/hotlot-staging/web/pages/auth/verify.vue?macro=true";
import { default as termse_45wYQRfS1Xpxo2B4qn8sBkSAFvBSESnI4hZOJe0Mjd8Meta } from "/var/www/hotlot-staging/web/pages/legal/terms.vue?macro=true";
import { default as how_45it_45worksQ5DV8XYSDpeRPXFvrUauwJoEJNV26GOis2RGIWAHQaUMeta } from "/var/www/hotlot-staging/web/pages/how-it-works.vue?macro=true";
import { default as _91id_93xeBMJGzQNs8R5DozDOc6R8dMR8yJ_45vfMpZEmFTR6gV0Meta } from "/var/www/hotlot-staging/web/pages/auctions/[id].vue?macro=true";
import { default as _91id_93r0Eon_45A2Zljn59EJAZl8dZcTb5ZIu2ILYaiDN4V3bAUMeta } from "/var/www/hotlot-staging/web/pages/products/[id].vue?macro=true";
import { default as indexijQAqBrT7UoyUrfhy1Rje_4592prfV7N8gGchyi05G6m4Meta } from "/var/www/hotlot-staging/web/pages/profile/index.vue?macro=true";
import { default as about_45usBR0OLiDngcir4dLeULD9fFRhXOG_45GwEVPysT7qO6ay4Meta } from "/var/www/hotlot-staging/web/pages/legal/about-us.vue?macro=true";
import { default as site_45mapScKj6XwUmbK4cuvzUghyjsdH4iSoR21QthSxgB_GGmkMeta } from "/var/www/hotlot-staging/web/pages/legal/site-map.vue?macro=true";
import { default as _91slug_93hKzUKB3cbKtnxCSc6sZZ5JsQxAwBmB2W3enZ1l28ohoMeta } from "/var/www/hotlot-staging/web/pages/category/[slug].vue?macro=true";
import { default as how_45to_45bidimyyoUORaxGGzJgFYGBhu8IEZGAIxg8JQpQQ4Mkb4TgMeta } from "/var/www/hotlot-staging/web/pages/legal/how-to-bid.vue?macro=true";
import { default as user_45guideLL3Tu4jWVJ2wnC_2V_45HfBW5iQ63g2VMyiNDSFdY1ox4Meta } from "/var/www/hotlot-staging/web/pages/legal/user-guide.vue?macro=true";
import { default as indexoZxBtp7bRNPBJf2xbcoXjdJjA8bKGTroP_45snITIlPeAMeta } from "/var/www/hotlot-staging/web/pages/profile/settings/index.vue?macro=true";
import { default as wallet9T73TbPG8mejH836Q8p8YVLkIf07UeXR25BvoIo0tYwMeta } from "/var/www/hotlot-staging/web/pages/profile/settings/wallet.vue?macro=true";
import { default as personalZhY_hn58Aa0bdEFOAfcJxg_kpTjJYmisNStJG1N7IwkMeta } from "/var/www/hotlot-staging/web/pages/profile/settings/personal.vue?macro=true";
import { default as securityAe1pkZV6yWv0foWZ6OPwncw9GZgLWLV8YRBnRbalEG4Meta } from "/var/www/hotlot-staging/web/pages/profile/settings/security.vue?macro=true";
import { default as items_45wonfXHY5UQGsvv5JM5GB_45UqaV713JEeQahxQpR8Hu7JmMYMeta } from "/var/www/hotlot-staging/web/pages/profile/settings/items-won.vue?macro=true";
import { default as win_45historyzOnSEw3uwIx8IzGeW9XDr_45B6xRBquIrHwsj24XpPTFgMeta } from "/var/www/hotlot-staging/web/pages/profile/settings/win-history.vue?macro=true";
import { default as bids_45historyWoNKy5VEtEgGLJACW5BbDVXyC_z6AIpIrxxbv0UfWgEMeta } from "/var/www/hotlot-staging/web/pages/profile/settings/bids-history.vue?macro=true";
import { default as notificationyX5YcYz3niaT7BH_4556bv7q2AwFExgeHscUPjq5oM4EQMeta } from "/var/www/hotlot-staging/web/pages/profile/settings/notification.vue?macro=true";
import { default as my_45active_45bidsj3Fn5x1g_2CP74Z6QO5__xaeVKpUHDJEqwgOlyraMNgMeta } from "/var/www/hotlot-staging/web/pages/profile/settings/my-active-bids.vue?macro=true";
import { default as payment_45methodz_ueVcdGWGnciAuBixfmgYRadDUoLG0zbNy_45A4QDgNIMeta } from "/var/www/hotlot-staging/web/pages/profile/settings/payment-method.vue?macro=true";
import { default as pickup_45appointments6leVG1TDcu_45oDk49oLDOZDG70bf7Ra6LAYADd4jrGdoMeta } from "/var/www/hotlot-staging/web/pages/profile/settings/pickup-appointments.vue?macro=true";
import { default as settingsAgkhnbA5uknNFLeXh7otSR97n0wgXCTwiuArN1dBU68Meta } from "/var/www/hotlot-staging/web/pages/profile/settings.vue?macro=true";
import { default as seller_45guidePLECoGVlgr_45N5IqkLxQi05P2pRdYFKURFWakx6i37Q4Meta } from "/var/www/hotlot-staging/web/pages/legal/seller-guide.vue?macro=true";
import { default as privacy_45policy2eprCRoh7v9TRdYSfb6KGtty69F92NUVTClUmqKMbTUMeta } from "/var/www/hotlot-staging/web/pages/legal/privacy-policy.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/var/www/hotlot-staging/web/pages/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/var/www/hotlot-staging/web/pages/contact.vue")
  },
  {
    name: "welcome",
    path: "/welcome",
    meta: welcomeChlKx71VLwYXOlqE31EgvLDduecwCLvlaEU67dVaEXcMeta || {},
    component: () => import("/var/www/hotlot-staging/web/pages/welcome.vue")
  },
  {
    name: "favorites",
    path: "/favorites",
    component: () => import("/var/www/hotlot-staging/web/pages/favorites.vue")
  },
  {
    name: "legal-faq",
    path: "/legal/faq",
    component: () => import("/var/www/hotlot-staging/web/pages/legal/faq.vue")
  },
  {
    name: "auth-verify",
    path: "/auth/verify",
    component: () => import("/var/www/hotlot-staging/web/pages/auth/verify.vue")
  },
  {
    name: "legal-terms",
    path: "/legal/terms",
    component: () => import("/var/www/hotlot-staging/web/pages/legal/terms.vue")
  },
  {
    name: "how-it-works",
    path: "/how-it-works",
    component: () => import("/var/www/hotlot-staging/web/pages/how-it-works.vue")
  },
  {
    name: "auctions-id",
    path: "/auctions/:id()",
    component: () => import("/var/www/hotlot-staging/web/pages/auctions/[id].vue")
  },
  {
    name: "products-id",
    path: "/products/:id()",
    component: () => import("/var/www/hotlot-staging/web/pages/products/[id].vue")
  },
  {
    name: "profile",
    path: "/profile",
    component: () => import("/var/www/hotlot-staging/web/pages/profile/index.vue")
  },
  {
    name: "legal-about-us",
    path: "/legal/about-us",
    component: () => import("/var/www/hotlot-staging/web/pages/legal/about-us.vue")
  },
  {
    name: "legal-site-map",
    path: "/legal/site-map",
    component: () => import("/var/www/hotlot-staging/web/pages/legal/site-map.vue")
  },
  {
    name: "category-slug",
    path: "/category/:slug()",
    component: () => import("/var/www/hotlot-staging/web/pages/category/[slug].vue")
  },
  {
    name: "legal-how-to-bid",
    path: "/legal/how-to-bid",
    component: () => import("/var/www/hotlot-staging/web/pages/legal/how-to-bid.vue")
  },
  {
    name: "legal-user-guide",
    path: "/legal/user-guide",
    component: () => import("/var/www/hotlot-staging/web/pages/legal/user-guide.vue")
  },
  {
    name: settingsAgkhnbA5uknNFLeXh7otSR97n0wgXCTwiuArN1dBU68Meta?.name,
    path: "/profile/settings",
    meta: settingsAgkhnbA5uknNFLeXh7otSR97n0wgXCTwiuArN1dBU68Meta || {},
    component: () => import("/var/www/hotlot-staging/web/pages/profile/settings.vue"),
    children: [
  {
    name: "profile-settings",
    path: "",
    meta: indexoZxBtp7bRNPBJf2xbcoXjdJjA8bKGTroP_45snITIlPeAMeta || {},
    component: () => import("/var/www/hotlot-staging/web/pages/profile/settings/index.vue")
  },
  {
    name: "profile-settings-wallet",
    path: "wallet",
    meta: wallet9T73TbPG8mejH836Q8p8YVLkIf07UeXR25BvoIo0tYwMeta || {},
    component: () => import("/var/www/hotlot-staging/web/pages/profile/settings/wallet.vue")
  },
  {
    name: "profile-settings-personal",
    path: "personal",
    component: () => import("/var/www/hotlot-staging/web/pages/profile/settings/personal.vue")
  },
  {
    name: "profile-settings-security",
    path: "security",
    component: () => import("/var/www/hotlot-staging/web/pages/profile/settings/security.vue")
  },
  {
    name: "profile-settings-items-won",
    path: "items-won",
    meta: items_45wonfXHY5UQGsvv5JM5GB_45UqaV713JEeQahxQpR8Hu7JmMYMeta || {},
    component: () => import("/var/www/hotlot-staging/web/pages/profile/settings/items-won.vue")
  },
  {
    name: "profile-settings-win-history",
    path: "win-history",
    meta: win_45historyzOnSEw3uwIx8IzGeW9XDr_45B6xRBquIrHwsj24XpPTFgMeta || {},
    component: () => import("/var/www/hotlot-staging/web/pages/profile/settings/win-history.vue")
  },
  {
    name: "profile-settings-bids-history",
    path: "bids-history",
    meta: bids_45historyWoNKy5VEtEgGLJACW5BbDVXyC_z6AIpIrxxbv0UfWgEMeta || {},
    component: () => import("/var/www/hotlot-staging/web/pages/profile/settings/bids-history.vue")
  },
  {
    name: "profile-settings-notification",
    path: "notification",
    component: () => import("/var/www/hotlot-staging/web/pages/profile/settings/notification.vue")
  },
  {
    name: "profile-settings-my-active-bids",
    path: "my-active-bids",
    meta: my_45active_45bidsj3Fn5x1g_2CP74Z6QO5__xaeVKpUHDJEqwgOlyraMNgMeta || {},
    component: () => import("/var/www/hotlot-staging/web/pages/profile/settings/my-active-bids.vue")
  },
  {
    name: "profile-settings-payment-method",
    path: "payment-method",
    component: () => import("/var/www/hotlot-staging/web/pages/profile/settings/payment-method.vue")
  },
  {
    name: "profile-settings-pickup-appointments",
    path: "pickup-appointments",
    meta: pickup_45appointments6leVG1TDcu_45oDk49oLDOZDG70bf7Ra6LAYADd4jrGdoMeta || {},
    component: () => import("/var/www/hotlot-staging/web/pages/profile/settings/pickup-appointments.vue")
  }
]
  },
  {
    name: "legal-seller-guide",
    path: "/legal/seller-guide",
    component: () => import("/var/www/hotlot-staging/web/pages/legal/seller-guide.vue")
  },
  {
    name: "legal-privacy-policy",
    path: "/legal/privacy-policy",
    component: () => import("/var/www/hotlot-staging/web/pages/legal/privacy-policy.vue")
  }
]